/**
 * 求職者情報
 */
$(function() {
    // 資格証明書名称 取消ボタンを押したら空に
    if($('.certificateFile-wrap').length) {
        $('.js-custom-file, .delete-btn').on(oEventNames.end, function(event) {
			if (!bIsScrolling) {
				event.preventDefault();
                $(this).closest('.certificateFile-wrap').find('[name^="file_name"]').val('');
            }
        });
    };
});
